import * as v from 'valibot';
import { AuthToken, Credentials, EmailAddress, GoogleIdToken, Password, Session, TeacherName, } from '../resources/index.js';
import { api } from './_base.js';
export const authContracts = api({
    // Session Management
    'POST /api/auth/login': {
        input: Credentials,
        output: v.object({
            session: Session,
        }),
        requiresSession: false,
        requiresProofOfWork: true,
    },
    'GET /api/auth/session': {
        input: v.object({}),
        output: v.object({
            authenticated: v.literal(true),
        }),
        requiresSession: true,
        // No requiresProofOfWork because session should be sufficient
    },
    'DELETE /api/auth/logout': {
        input: v.object({}),
        output: v.object({
            success: v.literal(true),
        }),
        requiresSession: true,
        // No requiresProofOfWork because session should be sufficient
    },
    // Third-party Authentication
    'POST /api/auth/google': {
        input: v.object({
            idToken: GoogleIdToken,
        }),
        output: v.object({
            success: v.boolean(),
            session: Session,
            message: v.optional(v.string()),
        }),
        requiresSession: false,
        requiresProofOfWork: true,
    },
    // Account Registration
    'POST /api/auth/signup/email-request': {
        input: v.object({
            email: v.pipe(EmailAddress, v.email()),
        }),
        output: v.object({
            success: v.boolean(),
            message: v.string(),
        }),
        requiresSession: false,
        requiresProofOfWork: true,
    },
    'GET /api/auth/signup/email-validate': {
        input: v.object({
            token: AuthToken,
        }),
        output: v.object({
            valid: v.boolean(),
            email: v.optional(EmailAddress),
        }),
        requiresSession: false,
        requiresProofOfWork: true,
    },
    'POST /api/auth/signup/complete': {
        input: v.object({
            token: AuthToken,
            name: TeacherName,
            password: Password,
        }),
        output: v.object({
            success: v.boolean(),
            session: Session,
        }),
        requiresSession: false,
        requiresProofOfWork: true,
    },
    // Password Management
    'PUT /api/auth/password/change': {
        input: v.object({
            currentPassword: Password,
            newPassword: Password,
        }),
        output: v.object({
            success: v.literal(true),
        }),
        requiresSession: true,
        requiresProofOfWork: true,
    },
    'POST /api/auth/password/reset-request': {
        input: v.object({
            email: EmailAddress,
        }),
        output: v.object({
            success: v.literal(true),
            message: v.string(),
        }),
        requiresSession: false,
        requiresProofOfWork: true,
    },
    'GET /api/auth/password/reset-validate': {
        input: v.object({
            token: AuthToken,
        }),
        output: v.object({
            valid: v.boolean(),
            email: v.optional(EmailAddress),
        }),
        requiresSession: false,
        requiresProofOfWork: true,
    },
    'POST /api/auth/password/reset-complete': {
        input: v.object({
            token: AuthToken,
            newPassword: Password,
        }),
        output: v.object({
            success: v.literal(true),
        }),
        requiresSession: false,
        requiresProofOfWork: true,
    },
    // Email Change Management
    'POST /api/auth/email/change-request': {
        input: v.object({
            newEmail: v.pipe(EmailAddress, v.email()),
        }),
        output: v.object({
            success: v.literal(true),
        }),
        requiresSession: true,
        requiresProofOfWork: true,
    },
    'GET /api/auth/email/change-validate': {
        input: v.object({
            token: AuthToken,
        }),
        output: v.union([
            v.object({
                valid: v.literal(true),
                oldEmail: EmailAddress,
                newEmail: EmailAddress,
                tokenType: v.picklist(['old', 'new']),
            }),
            v.object({
                valid: v.literal(false),
            }),
        ]),
        requiresSession: false,
        requiresProofOfWork: true,
    },
    'POST /api/auth/email/change-confirm': {
        input: v.object({
            token: AuthToken,
        }),
        output: v.object({
            success: v.literal(true),
            emailChanged: v.boolean(),
            pendingTokenType: v.optional(v.picklist(['old', 'new'])),
        }),
        requiresSession: false,
        requiresProofOfWork: true,
    },
    'POST /api/auth/email/change-reject': {
        input: v.object({
            token: AuthToken,
        }),
        output: v.object({
            success: v.literal(true),
        }),
        requiresSession: false,
        requiresProofOfWork: true,
    },
});
//# sourceMappingURL=auth.js.map